import React from "react";
import searchbarIcon from "@/assets/img/searchbarIcon.svg";

const SearchBoxComponent = ({ searchQuery, setSearchQuery }) => {
  return (
    <div style={{ marginBottom: "1rem", width: "300px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #E3E3E3",
          borderRadius: "6px",
          padding: "6px 10px",
          backgroundColor: "#fff",
        }}
      >
        <img
          src={searchbarIcon}
          alt="Search"
          style={{
            width: "16px",
            height: "16px",
            marginRight: "8px",
            opacity: 0.5,
          }}
        />
        <input
          type="text"
          placeholder="Search by Report Name, or Grouped By"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            border: "none",
            outline: "none",
            fontSize: "14px",
            color: "#6B7280",
            width: "100%",
          }}
        />
      </div>
    </div>
  );
};

export default SearchBoxComponent;
